export default {
      id: "info-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "sprite.1790164512331.svg#info-usage",
      toString: function () {
        return this.url;
      }
    }